export const Component = {
    MFAModalOtpLabel: '本操作涉及敏感信息，请输入FinPass验证码：',
    RangePickerDays30: '近30天',
    RangePickerDays60: '近60天',
    RangePickerDays90: '近90天',
    RangePickerAll: '全部',
};
